import { render, staticRenderFns } from "./mobileLogin.vue?vue&type=template&id=c8b5d1c4&scoped=true&"
import script from "./mobileLogin.vue?vue&type=script&lang=js&"
export * from "./mobileLogin.vue?vue&type=script&lang=js&"
import style0 from "./mobileLogin.vue?vue&type=style&index=0&id=c8b5d1c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b5d1c4",
  null
  
)

export default component.exports